import { SSOApi, SSOTypes } from '@kaltura-ott/ms-ott-clients';
import { AxiosResponse } from 'axios';

import { getConfig, KuxConfig, KuXConfig } from './config';
import { normalizeSSOResponse, NormalizedSSOResponse } from './sso-client.helper';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let client: any = null;

export const ssoClientInvoke = (partnerId: number, data: SSOTypes.InvokeRequest): Promise<NormalizedSSOResponse> => {
  const config: KuxConfig = getConfig(KuXConfig)('');

  if (!client) {
    // create instance of sso microservice client
    client = new SSOApi.Api().api;
  }

  // create request params
  const dataRequest: SSOTypes.InvokeRequest = data;
  dataRequest.ks = config.ks;

  // invoke service action
  return client
    .czInvokePost(partnerId, dataRequest, {
      baseURL: config.endpointUrl,
    })
    .then((response: AxiosResponse) => {
      const responseData: SSOTypes.InvokeOkResponse = response.data.result;
      return normalizeSSOResponse(responseData);
    });
};
